
const QCP_API = {
    getTestProduct: "/testProduct",
    getProductImages: "/productImages",
    getProductComments: "/productComments",
    getListing: "/qcplisting",
    addQcpInspect: "/addQcpInspect",
    uploadImage: "/uploadImage",
    getBoxData: "/QCP/Batche",
    addQcpData: "/QCP/QCP",
    addComment: "/QCP/Comments",
    addImage: "/QCP/Images",
    addFiles: "/QCP/Document",
    approvedBy: "/QCP/GetApprovedBy",
    getBoxNumber: "/QCP/Batches",
    getQCPData: "QCP/BatchNO",
    getUserDetails: "/Users/UserDetail",
    getQCPListing: "/QCP/QCPs", 
    QCPUpdate: "/QCP/QCP", 
    addBoxes: "/QCP/BoxNo",
    getBoxNumbersDetails: "/QCP/Detail",
    getQCPStatus: "/QCP/Status",

  };
  
  export default QCP_API;
  